module.exports = __webpack_public_path__ + "static/media/2.023ef950.jpg";